export const makeUpdateCategorySuccessMessage = name => `Category ${name} updated!`;
export const makeCreateCategorySuccessMessage = name => `Category ${name} created!`;
